// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5507":"65015ea28fea6f29","7038":"ec3f43cd8b0d3970"}[chunkId] + ".css";
};